import { render, staticRenderFns } from "./StickyNavbar.vue?vue&type=template&id=19136889&scoped=true"
import script from "./StickyNavbar.vue?vue&type=script&lang=ts"
export * from "./StickyNavbar.vue?vue&type=script&lang=ts"
import style0 from "./StickyNavbar.vue?vue&type=style&index=0&id=19136889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19136889",
  null
  
)

export default component.exports